import { format, formatDistanceToNow, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import type { BackupStatus, BackupTier } from "@/lib/backups.api";

export function formatDateTime(value: string): string {
  return format(parseISO(value), "dd MMM yyyy HH:mm", { locale: fr });
}

export function relativeTimeFromNow(value: string): string {
  return formatDistanceToNow(parseISO(value), { locale: fr, addSuffix: true });
}

export function formatBytes(bytes: number): string {
  if (bytes <= 0) return "0 Mo";
  const units = ["o", "Ko", "Mo", "Go", "To"];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, exponent);
  return `${value.toFixed(exponent === 0 ? 0 : 1)} ${units[exponent]}`;
}

export const TIER_LABELS: Record<BackupTier, string> = {
  daily: "Quotidien",
  weekly: "Hebdomadaire",
  monthly: "Mensuel",
  yearly: "Annuel",
};

export const STATUS_LABELS: Record<BackupStatus, string> = {
  running: "En cours",
  success: "Réussie",
  failed: "Échouée",
};

export function statusTone(status: BackupStatus): "neutral" | "warning" | "danger" {
  if (status === "failed") return "danger";
  if (status === "running") return "warning";
  return "neutral";
}

export function humanizeTriggeredBy(triggeredBy: string): string {
  if (triggeredBy === "cron") return "Automatique";
  if (triggeredBy.startsWith("manual:")) return "Manuelle";
  if (triggeredBy.startsWith("retry:")) return "Nouvelle tentative";
  return triggeredBy;
}
